module.exports = __webpack_public_path__ + "static/media/09_DSC0259.f6d5ba41.jpg";